import { Model } from 'modules/core/lib/mobx-rest'

import { IPayrollLegalEntityResource } from 'modules/contracts/store/collections/payrollLegalEntityResource'

class SpainOccupationCode extends Model<IPayrollLegalEntityResource> {
  static urlRoot() {
    return '/contracts/spain/occupation_codes'
  }
}

export default SpainOccupationCode
